<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <state-form :itemId="id" formType="Edit" subTitle="Edit State"></state-form>
      </div>
    </div>
  </div>
</template>

<script>
import StateForm from "@/views/state/components/Form.vue";

export default {
  name: "edit-state",
  data(){
    return {
      id : this.$route.params.id
    }
  },
  components: {
    StateForm,
  }
};
</script>